import { Booking } from "@/api/booking";
import { DateRange } from "react-day-picker";

export const buildQueryString = (params: Record<string, any>): string => {
  const queryParams: string[] = [];

  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];

      // Ignorar valores null o undefined
      if (value !== null && value !== undefined) {
        // Convertir camelCase a snake_case
        const snakeCaseKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        let formattedValue: string;

        if (value instanceof Date) {
          formattedValue = value.toISOString(); // Formatear fechas a ISO string
        } else if (typeof value === 'boolean') {
          formattedValue = value.toString(); // Convertir booleanos a string
        } else {
          formattedValue = String(value);
        }

        queryParams.push(`${snakeCaseKey}=${formattedValue}`);
      }
    }
  }

  if (queryParams.length > 0) {
    return `?${queryParams.join('&')}`;
  } else {
    return '';
  }
}

export function isKeyOfBooking(obj: any, key: string): key is keyof Booking {
  return key in obj;
}

export function filterBookings(
  bookings: Booking[],
  searchString?: string | undefined,
  completedFilter?: boolean | undefined,
  dateRangeFilter?: DateRange | undefined,
  paidFilter?: boolean | undefined,
  statusFilter?: number | undefined
): Booking[] {
  return bookings.filter((booking) => {
    // Filtro por searchString (en name, phone y email)
    const searchMatch =
      !searchString ||
      (booking.name && booking.name.toLowerCase().includes(String(searchString).toLowerCase())) ||
      (booking.phone && booking.phone.includes(String(searchString))) ||
      (booking.email && booking.email.toLowerCase().includes(String(searchString).toLowerCase()));

    // Filtro por completed
    const completedMatch = completedFilter == null || booking.completed === completedFilter;

    // Filtro por startDate (mayor o igual a from, y menor o igual a to si existe)
    const startDateMatch = !dateRangeFilter?.from || booking.startDate >= dateRangeFilter.from;

    const endDateMatch = !dateRangeFilter?.to || booking.startDate <= dateRangeFilter.to;

    // Filtro por paid
    const paidMatch = paidFilter == null || booking.paid === paidFilter;

    const statusMatch = statusFilter == null || booking.status === statusFilter;

    return searchMatch && completedMatch && startDateMatch && endDateMatch && paidMatch && statusMatch;
  });
}

export function findEmailErrorInErrors(errors: any[] | string): string | null {
  if (typeof errors === 'string') {
    return null;
  }

  for (const error of errors) {
    if (typeof error === 'object' && error !== null && typeof error?.email === 'string') {
      return error.email;
    }
  }
  return null;
}

export function findPhoneErrorInErrors(errors: any[] | string): string | null {
  if (typeof errors === 'string') {
    return null;
  }

  for (const error of errors) {
    if (typeof error === 'object' && error !== null && typeof error?.phone === 'string') {
      return error.phone;
    }
  }
  return null;
}

export const getTruncatedText = (text: string, maxLength: number) => {
  if (text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
};